var route = {
    path : '/oauthBindPhone',
    getComponent(nextState, cb) {
        require.ensure([], (require) => {
            cb(null, require('../pc/components/ThirdPartyOAuth/BindPhone.jsx').default)
        }, 'BindPhone')
    }
}


export default route;


// WEBPACK FOOTER //
// ./src/routes/bindPhone.js